import { Block } from "@components/Block/Block";
import { Concertina } from "@components/Concertina/Concertina";
import { JWMHtml } from "@components/JWMHtml/JWMHtml";
import { CMSAccordionPane } from "@jwm/types/CMSAccordionProps";
import { CMSBlock } from "@jwm/types/CMSBlock";
import { CMSSectionProps } from "@jwm/types/CMSSectionProps";
import { default as cmsMapper } from "@utils/cms-mapper";
import React from "react";

import style from "../style.module.scss";
import { trackingHelpersProps } from "../types";

interface AccordionBlockProps {
    content: CMSBlock["accordion"];
    placement?: string;
    locale?: string;
    trackingHelpers: trackingHelpersProps;
    sectionBackground?: string;
    sectionIndex?: number;
    siteSpecialty?: {
        type: string;
        title: string;
    };
    sectionContent?: CMSSectionProps;
}

export const AccordionBlock = ({
    content,
    placement,
    locale,
    trackingHelpers,
    sectionBackground,
    sectionIndex,
    siteSpecialty,
    sectionContent,
}: AccordionBlockProps): JSX.Element => {
    const type = cmsMapper.mapConcertinaType(content?.accordion_type);

    const items = content.panes.map(({ pane }: CMSAccordionPane) => {
        trackingHelpers.numPanes++;
        const title = <JWMHtml showGlossary={false}>{pane?.title}</JWMHtml>;
        const titleString = pane?.title;

        return {
            title: title,
            titleString: titleString,
            content:
                pane.content &&
                pane.content.map((block: CMSBlock, i: number) => {
                    return (
                        <Block
                            key={i}
                            content={block}
                            placement={`${placement}:pane-${trackingHelpers.numPanes}`}
                            locale={locale}
                            sectionBackground={sectionBackground}
                            sectionIndex={sectionIndex}
                            siteSpecialty={siteSpecialty}
                            sectionContent={sectionContent}
                        />
                    );
                }),
        };
    });

    return (
        <div className={style.concertina}>
            <Concertina items={items} type={type} placement={placement} siteSpecialty={siteSpecialty} />
        </div>
    );
};
